export default "__VITE_ASSET__CknzzSHM__";